module.exports = __webpack_public_path__ + "static/img/close-512.2b499a27.png";